// extracted by mini-css-extract-plugin
export var emailBlockLink = "_kf-0";